import {Component} from 'san';
import throttle from 'lodash.throttle';
import styles from './style/index.module.less';

export default class Bottom extends Component {
    static template = require('./index.html');
    static computed = {
        imgSrc() {
            const {domain, browser} = this.data.get('common');
            if (browser.isie) {
                return `${domain.static}static/superman/img/blank.gif`;
            }
            return `${domain.static}static/superman/img/copy_rignt_${browser.ie6 ? '24' : '8'}.png`;

        }
    };
    initData() {
        return {
            styles,
            showText: false,
            sendShowLog: false
        };
    }
    attached() {
        const scrollFn = throttle(this.scrollHandler.bind(this), 500);
        window.addEventListener('scroll', scrollFn);
        this.data.set('showBtn', false);
    }
    scrollHandler() {
        const scrollTop = window.pageYOffset
                        || document.documentElement.scrollTop
                        || document.body.scrollTop
                        || 0;
        if (scrollTop > 100) {
            if (!this.data.get('sendShowLog')) {
                this.data.set('sendShowLog', true);
                this.storeDispatch('backTop:showLog');
            }
            this.ref('backTop').style.visibility = 'visible';
        } else {
            this.ref('backTop').style.visibility = 'hidden';
        }
    }
    onMouseEnter() {
        this.data.set('showText', true);
    }
    onMouseLeave() {
        setTimeout(() => {
            this.data.set('showText', false);
        }, 200);
    }
    backTop() {
        this.storeDispatch('backTop:clkLog');
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
};
